import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TauresMessageModule } from '@taures/taures-components/taures-message';
import { DatePicker } from 'primeng/datepicker';
import { FloatLabel } from 'primeng/floatlabel';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-date-range',
  templateUrl: './date-range.component.html',
  styleUrls: ['./date-range.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [TauresMessageModule, DatePicker, FloatLabel, ReactiveFormsModule, AsyncPipe],
  standalone: true
})
export class DateRangeComponent {
  public vonDateFormControl!: FormControl<Date | null>;
  public bisDateFormControl!: FormControl<Date | null>;
  public minBisDate$!: Observable<Date | null>;
  public maxVonDate$!: Observable<Date | null>;

  @Input()
  public set vonDate(vonDateFormControl: FormControl<Date | null>) {
    this.vonDateFormControl = vonDateFormControl;
    this.minBisDate$ = this.vonDateFormControl.valueChanges.pipe(
      map((vonDate: Date | null): Date | null => {
        return vonDate ?? null;
      })
    );
  }

  @Input()
  public set bisDate(bisDateFormControl: FormControl<Date | null>) {
    this.bisDateFormControl = bisDateFormControl;
    this.maxVonDate$ = this.bisDateFormControl.valueChanges.pipe(
      map((bisDate: Date | null): Date | null => {
        return bisDate ?? null;
      })
    );
  }

  public get vonDate(): FormControl<Date | null> {
    return this.vonDateFormControl;
  }

  public get bisDate(): FormControl<Date | null> {
    return this.bisDateFormControl;
  }
}
